import { render, staticRenderFns } from "./CustomerNew.vue?vue&type=template&id=f263c5ba&"
import script from "./CustomerNew.vue?vue&type=script&lang=js&"
export * from "./CustomerNew.vue?vue&type=script&lang=js&"
import style0 from "./CustomerNew.vue?vue&type=style&index=0&id=f263c5ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports